import React from 'react';
import styles from "../styles/pages/InstructivePage.module.css";
import Nav from '../components/app/Nav';
import Footer from '../components/app/Footer';
import ReversoIMG from '../assets/app/instructivePage/reverso.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faTags,
    faExclamationTriangle
} from '@fortawesome/free-solid-svg-icons';

const InstructivePage: React.FC = () => {
    return (
        <div className={styles.instructivePage}>
            <Nav />
            <main className={styles.mainContainer}>
                {/* Hero Section */}
                <div className={styles.instructiveHero}>
                    <div className={styles.instructiveHeroContent}>
                        <div className={styles.instructiveHeroLeft}>
                            <p className={styles.headerBrand}>elPaket</p>
                            <h1 className={styles.instructiveHeroTitle}>¿Cómo colocar la etiqueta?</h1>
                            <p className={styles.instructiveSubtitleHero}>
                                Sigue estas instrucciones para asegurar que tu paquete sea procesado y entregado sin contratiempos.
                            </p>
                        </div>
                        <div className={styles.instructiveHeroRight}>
                            <FontAwesomeIcon icon={faTags} className={styles.instructiveHeroIcon} />
                        </div>
                    </div>
                </div>

                {/* Body Content */}
                <div className={styles.instructiveBody}>
                    <div className={styles.instructiveContainer}>
                        {/* Paso Único */}
                        <section className={styles.stepCard}>
                            <div className={styles.stepHeader}>
                                <div className={styles.stepIcon}>
                                    <FontAwesomeIcon icon={faTags} />
                                </div>
                                <h3>Etiqueta de Envío</h3>
                            </div>
                            <p>Debes pegar la etiqueta en el reverso del paquete, de forma visible, plana y sin dobleces.</p>
                            <div className={styles.cardImageWrapper}>
                                <img src={ReversoIMG} alt="Reverso del paquete" className={styles.cardImage} />
                            </div>
                        </section>

                        {/* Right Side Column for alerts/information */}
                        <div className={styles.sideColumn}>
                            {/* Alert Section 1: Label Placement */}
                            <section className={styles.alertSection}>
                                <div className={styles.alertHeader}>
                                    <div className={styles.alertIcon}>
                                        <FontAwesomeIcon icon={faExclamationTriangle} />
                                    </div>
                                    <h3>Información Importante</h3>
                                </div>
                                <div className={styles.alertText}>
                                    <p style={{ marginBottom: '16px' }}>
                                        La etiqueta es indispensable para el proceso de envío y debe cumplir con las instrucciones de colocación.
                                    </p>
                                    <p>
                                        Un error en la ubicación o la ausencia de la etiqueta podría impedir la entrega de tu paquete.
                                    </p>
                                </div>
                            </section>

                            {/* Alert Section 2: Dimensions & Weight Audit */}
                            <section className={styles.alertSection}>
                                <div className={styles.alertHeader}>
                                    <div className={styles.alertIcon}>
                                        <FontAwesomeIcon icon={faExclamationTriangle} />
                                    </div>
                                    <h3>Declaración de Peso y Medidas</h3>
                                </div>
                                <div className={styles.alertText}>
                                    <p style={{ marginBottom: '16px' }}>
                                        Las dimensiones y el peso ingresados deben ser verídicos.
                                    </p>
                                    <p>
                                        Estos datos están sujetos a recálculo y auditoría por parte del courier final.
                                    </p>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default InstructivePage;

